import { User, MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from './SectionHeader';
import { SummaryRow } from './SummaryRow';

interface CustomerSectionProps {
  name: string;
  phone: string;
  province: string;
  area: string;
  address: string;
  deliveryInstructions?: string;
}

export function CustomerSection({
  name,
  phone,
  province,
  area,
  address,
  deliveryInstructions,
}: CustomerSectionProps) {
  const { t } = useTranslation();

  return (
    <div className='rounded-2xl border border-sd-border bg-sd-card p-5'>
      <SectionHeader icon={User} title={String(t('customer_details'))} />

      <div className='grid grid-cols-1 sm:grid-cols-2 gap-x-6 divide-y sm:divide-y-0 divide-sd-border'>
        {/* Left column */}
        <div className='divide-y divide-sd-border'>
          <SummaryRow label={String(t('name'))} value={name} />
          <SummaryRow label={String(t('phone'))}>
            <div className='flex items-center gap-2'>
              <span className='text-sm font-medium' dir='ltr'>
                {phone || '—'}
              </span>
              {phone && (
                <a
                  href={`https://wa.me/${phone.replace(/[^0-9]/g, '')}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex h-6 w-6 items-center justify-center rounded-md hover:bg-sd-muted transition-colors'
                  aria-label='WhatsApp'
                >
                  <MessageCircle className='h-3.5 w-3.5 text-[rgb(37,211,102)]' />
                </a>
              )}
            </div>
          </SummaryRow>
          <SummaryRow label={String(t('province'))} value={province} />
        </div>

        {/* Right column */}
        <div className='divide-y divide-sd-border'>
          <SummaryRow label={String(t('area'))} value={area} />
          <SummaryRow label={String(t('address'))} value={address} />
          {deliveryInstructions !== undefined && (
            <SummaryRow
              label={String(t('delivery_instructions'))}
              value={deliveryInstructions || '—'}
            />
          )}
        </div>
      </div>
    </div>
  );
}
